import { useBreakpoint } from '../../hooks/useBreakpoint';
import Tile, { TileProps } from '../../components/tile/Tile';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SectionHeader, { SectionHeaderProps } from '../../home/components/SectionHeader';

export interface TilesBlockProps {
  tiles?: TileProps[];
  type?: 'large' | 'basic' | 'small';
  sectionHeader?: SectionHeaderProps;
}

const TilesBlock: React.FC<TilesBlockProps> = ({ tiles = [], type = 'basic', sectionHeader }) => {
  const { isExtraSmall, isSmall, isMedium } = useBreakpoint();
  const isMobile = isExtraSmall || isSmall || isMedium;

  const renderTiles = () => {
    if (isMobile && type === 'large') {
      return (
        <Swiper spaceBetween={6} slidesPerView={1.35}>
          {tiles?.map((tile, index) => (
            <SwiperSlide key={index}>
              <Tile {...tile} size={type} />
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }

    if (isMobile && type === 'small') {
      return (
        <Swiper spaceBetween={16} slidesPerView={2.2} loop>
          {tiles?.map((tile, index) => (
            <SwiperSlide key={index}>
              <Tile {...tile} size={type} />
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }

    return tiles?.map((tile, index) => <Tile {...tile} size={type} key={index} />);
  };

  return (
    <div className="e-com__tiles">
      {sectionHeader && <SectionHeader {...sectionHeader} />}
      {tiles && <div className={` e-com__tiles--${type}`}>{renderTiles()}</div>}
    </div>
  );
};

export default TilesBlock;
